<template>
  <div id="pension" class="c-content">
    <banner-general :content="banner"></banner-general>

    <div class="c-community__senicare c-standard">
      <img :src="senicare.image" :alt="senicare.title">
      <h3 class='title_h3'>{{ senicare.title }}</h3>
      <p>{{ senicare.text }}</p>
      <q-btn class='c-community__senicare--btn' unelevated rounded :label="senicare.btn" padding="3px 30px" style="background-color: #009040; color: #ffffff"/>
    </div>

    <exhibition-items :content="exhibition"></exhibition-items>

  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'
  import BannerGeneral from '../layout/bannerGeneral.vue'
  import ExhibitionItems from '../layout/exhibitionItems.vue'

  export default {
    name: 'pension',
    components: {
      'q-btn': Quasar.QBtn,
      'banner-general': BannerGeneral,
      'exhibition-items': ExhibitionItems
    },
    data(){
      return {
        banner: {
          type: '1',
          img: require('../../assets/img/banner_pension.jpg'),
          title: this.$t('homepage.publicity.publicity_2.title'),
          content: this.$t('homepage.publicity.publicity_2.content'),
        },
        senicare:{
          image: require('../../assets/img/senicare.png'),
          title: this.$t('pension.senicare.title'),
          text: this.$t('pension.senicare.content'),
          btn: this.$t('pension.senicare.button_text')
        },
        exhibition: [
          {url: require('../../assets/img/solution_homecare.png'), link:'programPension', title: this.$t('program_pension.theme_1.title'), content: this.$t('program_pension.theme_1.content'), color: '#232323', contentColor:'#181818', bgColor: '#F1F4F1', btnColor: '#164687'},
          {url: require('../../assets/img/solution_communitycare.png'), link:'programPension', title: this.$t('program_pension.theme_2.title'), content: this.$t('program_pension.theme_2.content'), color: '#FFFFFF', contentColor:'#CBCBCB', bgColor: '#434543', btnColor: '#C6C6C6'},
          {url: require('../../assets/img/solution_institutionalcare.png'), link:'programPension', title: this.$t('program_pension.theme_3.title'), content: this.$t('program_pension.theme_3.content'), color: '#232323', contentColor:'#181818', bgColor: '#F1F4F1', btnColor: '#164687'}
        ],
      }
    },
    computed: {

    },
    created () {

    },
    methods: {

    },
  }
</script>

<style>

</style>
